'use client';

import { c as _c } from "react/compiler-runtime";
import type { Map as MapLibreMap } from 'maplibre-gl';
import { createContext, type ReactNode, useContext, useEffect, useRef, useState } from 'react';
import { removeMapDeferred } from './map-lifecycle';
interface MapContextValue {
  map: MapLibreMap | null;
  setMap: (map: MapLibreMap | null) => void;
}
export const MapContext = createContext<MapContextValue | null>(null);
export function useMapContext() {
  const context = useContext(MapContext);
  if (!context) {
    throw new Error("useMapContext must be used within a MapProvider");
  }
  return context;
}
export function MapProvider(t0) {
  const $ = _c(8);
  const {
    children
  } = t0;
  const [map, setMap] = useState(null);
  const latestMapRef = useRef(null);
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => () => {
      const mapToRemove = latestMapRef.current;
      latestMapRef.current = null;
      if (!mapToRemove) {
        return;
      }
      removeMapDeferred(mapToRemove);
    };
    t2 = [];
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  useEffect(t1, t2);
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = newMap => {
      const previousMap = latestMapRef.current;
      latestMapRef.current = newMap;
      if (previousMap && previousMap !== newMap) {
        removeMapDeferred(previousMap);
      }
      setMap(newMap);
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== map) {
    t4 = {
      map,
      setMap: t3
    };
    $[3] = map;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const value = t4;
  let t5;
  if ($[5] !== children || $[6] !== value) {
    t5 = <MapContext.Provider value={value}>{children}</MapContext.Provider>;
    $[5] = children;
    $[6] = value;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  return t5;
}